<div class="modal-header">
  <h5 class="w-100">
    <strong>Template file Excel</strong>
  </h5>
</div>

<div class="modal-body">
  <div class="scrollable-div">
    <table mat-table [dataSource]="campi" class="w-100">
      <ng-container matColumnDef="colonna">
        <th mat-header-cell *matHeaderCellDef>Colonna</th>
        <td mat-cell *matCellDef="let row"><code>{{ row.colonna }}</code></td>
      </ng-container>

      <ng-container matColumnDef="tipo">
        <th mat-header-cell *matHeaderCellDef>Tipo</th>
        <td mat-cell *matCellDef="let row">{{ row.tipo }}</td>
      </ng-container>

      <ng-container matColumnDef="obbligatorio">
        <th mat-header-cell *matHeaderCellDef>Obbligatorio</th>
        <td mat-cell *matCellDef="let row">{{ row.obbligatorio }}</td>
      </ng-container>

      <ng-container matColumnDef="note">
        <th mat-header-cell *matHeaderCellDef>Note</th>
        <td mat-cell *matCellDef="let row">{{ row.note }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let row; columns: columns"></tr>
    </table>
  </div>
</div>

<div class="d-flex justify-content-end align-items-center mt-3">
  <button mat-button (click)="close()">Chiudi</button>
</div>
